var _ellipse, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGumroadG(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.8287,
    cy: 19.1359,
    rx: 14.1714,
    ry: 13.6765,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1714 29.9464C24.4032 29.9464 31.1241 23.4995 31.1241 15.4887C31.1241 7.478 24.4032 1.03101 16.1714 1.03101C7.9397 1.03101 1.21875 7.478 1.21875 15.4887C1.21875 23.4995 7.9397 29.9464 16.1714 29.9464Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 1.5625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0467 22.7827C10.862 22.7827 8.40039 19.4024 8.40039 15.1976C8.40039 10.8279 11.1081 7.28271 16.2774 7.28271C21.6109 7.28271 23.416 10.9104 23.4981 12.9715H19.6416C19.5596 11.8173 18.5749 10.0859 16.1954 10.0859C13.6518 10.0859 12.0107 12.312 12.0107 15.0327C12.0107 17.7535 13.6518 19.9795 16.1954 19.9795C18.4929 19.9795 19.4775 18.1657 19.8878 16.3519H16.1954V14.8678H23.9432V22.4529H20.5442V17.671C20.298 19.4024 19.2313 22.7827 15.0467 22.7827Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGumroadG);
export default __webpack_public_path__ + "static/media/GumroadG.73331f26a7eb39b05fa7dc60f03257e6.svg";
export { ForwardRef as ReactComponent };